export const ACTIVE = 'active';
export const CANCELLED = 'cancelled';
export const INACTIVE = 'inactive';
export const PAYMENT_FAILED = 'payment_failed';
export const WITHIN_GRACE_PERIOD = 'within_grace_period';
export const PAUSED = 'paused';
export const INITIAL = 'initial';

export const MANAGEABLE_MEMBERSHIP_STATUSES = [
  ACTIVE,
  PAUSED,
  WITHIN_GRACE_PERIOD,
  PAYMENT_FAILED,
  CANCELLED,
  INITIAL,
];

export const EARNED = 0;
export const REDEEMED = 1;
export const EXPIRING_SOON = 2;
